import { IconButton } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import GenerateIcon from '../../components/GenerateIcon'
import { BrowserQRCodeReader } from '@zxing/browser';
import OnlyAuthorizedMessage from '../../components/OnlyAuthorizedMessage';

interface IProps {
    shown?: boolean,
    handleDecodedText: (result: string) => void,
    handleClose: () => void
}

export default function ScanQRCode(props: IProps) {
    

    const videoRef = useRef<HTMLVideoElement>(null)
    const codeReaderRef = useRef<BrowserQRCodeReader | null>(null)
    const scanControlRef = useRef<any>(null)

    const { shown, handleDecodedText, handleClose } = props

    const containerBaseClassName: string = "qr-code-scanner-container"
    const [containerClassName, setContainerClassName] = useState<string>(containerBaseClassName)

    const [errorMessage, setErrorMessage] = useState<string>("")

    useEffect(() => {
        setContainerClassName(shown ? containerBaseClassName + " active" : containerBaseClassName)

        if (shown) {
            const codeReader = new BrowserQRCodeReader()
            codeReaderRef.current = codeReader

            // const startScan = async () => {
            //     try {
            //       const devices = await BrowserQRCodeReader.listVideoInputDevices()
              
            //       // Try to find a rear-facing camera
            //       const backCamera = devices.find(d => d.label.toLowerCase().includes("back")) || devices[0]
            //       const selectedDeviceId = backCamera?.deviceId
              
            //       if (selectedDeviceId && videoRef.current) {
            //         scanControlRef.current = await codeReader.decodeFromVideoDevice(
            //           selectedDeviceId,
            //           videoRef.current,
            //           (result, error, controls) => {
            //             if (result) {
            //               handleDecodedText(result.getText())
            //               controls.stop()
            //               handleClose()
            //             }
            //           }
            //         )
            //       }
            //     } catch (err) {
            //       console.error("QR scanner failed to start:", err)
            //     }
            //   }
            const startScan = async () => {
              try {
                  // 🔐 Force browser to prompt for permission
                  await navigator.mediaDevices.getUserMedia({ video: true })
  
                  const devices = await BrowserQRCodeReader.listVideoInputDevices()
                  const backCamera = devices.find(d => d.label.toLowerCase().includes("back")) || devices[0]
                  const selectedDeviceId = backCamera?.deviceId
  
                  if (selectedDeviceId && videoRef.current) {
                      const codeReader = new BrowserQRCodeReader()
                      codeReaderRef.current = codeReader
  
                      scanControlRef.current = await codeReader.decodeFromVideoDevice(
                          selectedDeviceId,
                          videoRef.current,
                          (result, error, controls) => {
                              if (result) {
                                  handleDecodedText(result.getText())
                                  controls.stop()
                                  handleClose()
                              }
                          }
                      )
                  }
              } catch (err: any) {
                  console.error("Camera access error:", err)
  
                  if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
                      setErrorMessage("Camera access was denied. Please enable it in your browser settings to scan QR codes.")
                  } else if (err.name === "NotFoundError") {
                      setErrorMessage("No camera was found. Please connect a camera and try again.")
                  } else {
                      setErrorMessage("An unexpected error occurred while accessing the camera.")
                  }
              }
          }

            startScan()
        }

        return () => {
            // Cleanup: stop scanning when closed/unmounted
            try {
                scanControlRef.current?.stop()
            } catch (e) {
                console.warn("Scanner cleanup failed", e)
            }
        }
    }, [shown])
    

    return(
        <div className={containerClassName}>

            <div className="header-box-of-qr-code-scanner-container">
                <div className="content-of-header-box-of-qr-code-scanner-container">

                    <h3>Scan QR Code</h3>

                    <IconButton onClick={() => handleClose()}>
                        <GenerateIcon icon="close" />
                    </IconButton>

                </div>
            </div>

            <div className="content-of-qr-code-scanner-container">
                {errorMessage && (
                    <div className="qr-code-scanner-error-overlay">
                        <div className="content-of-qr-code-scanner-error-overlay">
                          <OnlyAuthorizedMessage title="Something went wrong :(" message={errorMessage} hideButton />
                        </div>
                    </div>
                )}
                <video ref={videoRef} style={{ width: '100%' }} />
            </div>

        </div>
    )
}